import React, { useEffect, useState } from 'react';
import { Box, Button, Group, Text } from '@mantine/core';

const CONSENT_KEY = 'cookie_consent';

export const CookieConsent: React.FC = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    if (!localStorage.getItem(CONSENT_KEY)) {
      setVisible(true);
    }

    const handleReset = () => setVisible(true);
    window.addEventListener('show-cookie-consent', handleReset);
    return () => window.removeEventListener('show-cookie-consent', handleReset);
  }, []);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <Box
      style={{
        position: 'fixed',
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 9999,
        backgroundColor: 'rgba(10, 10, 10, 0.95)',
        backdropFilter: 'blur(20px)',
        WebkitBackdropFilter: 'blur(20px)',
        borderTop: '1px solid rgba(255, 255, 255, 0.1)',
        padding: '16px 24px',
      }}
    >
      <Box
        style={{
          maxWidth: 1200,
          margin: '0 auto',
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          gap: 24,
          flexWrap: 'wrap',
        }}
      >
        <Text size='sm' c='rgba(255, 255, 255, 0.7)' style={{ flex: 1, minWidth: 280, lineHeight: 1.6 }}>
          We use essential browser storage to maintain your shopping cart and currency preference. Our checkout is
          powered by Fourthwall, which processes payments securely. By continuing to use this site, you agree to our{' '}
          <Text
            component='a'
            href='https://fourthwall.com/legal/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            size='sm'
            c='rgba(255, 152, 0, 0.9)'
            style={{ textDecoration: 'underline' }}
          >
            Privacy Policy
          </Text>
          .
        </Text>
        <Group gap={12} style={{ flexShrink: 0 }}>
          <Button
            variant='subtle'
            size='sm'
            component='a'
            href='https://fourthwall.com/legal/privacy-policy'
            target='_blank'
            rel='noopener noreferrer'
            style={{ color: 'rgba(255, 255, 255, 0.5)', fontSize: 14 }}
          >
            Learn More
          </Button>
          <Button
            size='sm'
            onClick={accept}
            style={{
              backgroundColor: '#FF9800',
              color: '#000',
              fontWeight: 600,
              fontSize: 14,
            }}
          >
            Accept
          </Button>
        </Group>
      </Box>
    </Box>
  );
};
